import { Toast } from '@base-ui/react/toast'
import { overlayCopy } from '@/copy'
import { Icon } from '../Icon/Icon'
import { IconButton } from '../IconButton/IconButton'
import styles from './Toast.module.css'
import { toastManager } from './toastManager'

const GLYPH = {
  success: 'check-circled',
  danger: 'cross-circled',
  info: 'info-circled',
} as const

function ToastList() {
  const { toasts } = Toast.useToastManager()

  // Deviation from Base UI defaults: it marks a high-priority root and every
  // close button aria-hidden until the stack is focused or hovered. Danger
  // toasts persist and the dismiss button must have a real accessible name
  // (Toast card), so neither is ever hidden here. Escape on a focused toast is
  // consumed: Base UI closes it but lets the key bubble, which would also close
  // a dialog or the thread behind it.
  return toasts.map((t) => (
    <Toast.Root
      key={t.id}
      toast={t}
      className={styles.toast}
      data-tone={t.type}
      aria-hidden={false}
      onKeyDown={(event) => {
        if (event.key === 'Escape') {
          event.preventDefault()
          event.stopPropagation()
        }
      }}
    >
      <Icon
        name={GLYPH[t.type as keyof typeof GLYPH]}
        size="icon-inline"
        className={styles.glyph}
      />
      <Toast.Title render={<p />} className={styles.message} />
      {t.actionProps && <Toast.Action className={styles.action} />}
      <Toast.Close
        aria-hidden={false}
        render={
          <IconButton
            label={overlayCopy.dismissNotification}
            ground="surface"
            className={styles.dismiss}
          >
            <Icon name="cross-2" />
          </IconButton>
        }
      />
    </Toast.Root>
  ))
}

export function Toaster() {
  return (
    <Toast.Provider toastManager={toastManager}>
      <Toast.Portal>
        <Toast.Viewport className={styles.viewport}>
          <ToastList />
        </Toast.Viewport>
      </Toast.Portal>
    </Toast.Provider>
  )
}
